// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--HAxrU";
export var header = "styles-module--header--hINKp";
export var link = "styles-module--link--wgHGf";